import React, {useEffect, useState} from 'react'
import {ScrollToTopStyle} from './style'
import ArrowTop from 'assets/icons/arrow-top'

const ScrollToTop = ({bottom}) => {
  const [showTopBtn, setShowTopBtn] = useState(false)
  useEffect(() => {
    window.addEventListener('scroll', () => {
      // eslint-disable-next-line no-magic-numbers
      if (window.scrollY > 400) {
        setShowTopBtn(true)
      } else {
        setShowTopBtn(false)
      }
    })
  }, [])

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  return (
    <>
      {showTopBtn && (
        <ScrollToTopStyle bottom={bottom} onClick={goToTop}>
          <ArrowTop />
        </ScrollToTopStyle>
      )}
    </>
  )
}

export default ScrollToTop
